export const currencyFormat = (numString) => {
    if (!numString) return ""
    if (!isNaN(numString)) numString = numString.toString()

    return Math.ceil(numString).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}